import React, { useState } from "react";
import { DiscountsItemContainer } from "./DiscountsItemContainer";
import { useProductsData } from "../menu/products/useProductsData";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import { useSideTabs } from "../../hooks/useSideTabs";
import { DisableRouteComponent } from '../util/DisableRouteComponent';

export function DiscountsContainer(props: any) {
    const [discounts, setDiscounts] = useState<any[]>([]);
    const position = useSideTabs(props.tab);
    const selectedId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { callAPI, isLoading } = useProductsData(APIExtensions.discounts, selectedId, setDiscounts, {
        "sort_field": "created_on",
        "sort_direction": "desc"
    });
    return <DisableRouteComponent pageKey={position}>
        <>
            <DiscountsItemContainer
                isLoading={isLoading}
                discountsList={discounts}
                callDiscountsAPI={callAPI}
                venueId={selectedId}
            />
        </>
    </DisableRouteComponent>



}